"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = void 0;
var BaseEntity_1 = require("../../../models/concrete/BaseEntity");
;
var Product = /** @class */ (function (_super) {
    __extends(Product, _super);
    function Product(data, meta) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        var _this = _super.call(this, data) || this;
        _this.code = data.code;
        _this.name = data.name;
        _this.slug = data.slug;
        _this.description = data.description;
        _this.shortDescription = data.short_description;
        _this.price = data.price;
        _this.oldPrice = data.price_old;
        _this.newPrice = data.price_new;
        _this.rating = data.rating;
        _this.imageId = data.image_id;
        _this.imageIds = data.images_ids;
        _this.quantity = data.quantity;
        _this.countStep = data.count_step;
        _this.depth = data.depth;
        _this.weight = data.weight;
        _this.width = data.width;
        _this.height = data.height;
        _this.isHit = data.is_hit;
        _this.isNew = data.is_new;
        _this.isSpecial = data.is_special;
        _this.url = data.url;
        _this.allowOutOfStock = data.allow_out_of_stock;
        _this.unit = data.unit;
        _this.category = {
            id: (_a = data === null || data === void 0 ? void 0 : data.category) === null || _a === void 0 ? void 0 : _a.id,
            name: (_b = data === null || data === void 0 ? void 0 : data.category) === null || _b === void 0 ? void 0 : _b.name
        };
        _this.categories = (_c = data.categories) === null || _c === void 0 ? void 0 : _c.map(function (c) {
            return {
                id: c.id,
                parentId: c.parent_id,
                name: c.name,
                slug: c.slug
            };
        });
        _this.tags = data.tags;
        _this.photos = (_d = data.photos) === null || _d === void 0 ? void 0 : _d.map(function (p) {
            return {
                caption: p.caption,
                preview: p.preview,
                src: p.src,
                thumb: p.thumb
            };
        });
        _this.characteristics = (_e = data.characteristics) === null || _e === void 0 ? void 0 : _e.map(function (c) {
            var _a;
            return {
                name: c.name,
                characteristics: (_a = c.characteristics) === null || _a === void 0 ? void 0 : _a.map(function (c) {
                    return {
                        id: c.id,
                        name: c.name,
                        slug: c.slug,
                        values: c === null || c === void 0 ? void 0 : c.values.map(function (v) {
                            return {
                                id: v.id,
                                slug: v.slug,
                                value: v.value,
                                imageId: v.image_id,
                                sort: v.sort
                            };
                        }),
                        help: c.help,
                        unit: c.unit,
                        showInFilter: c.show_in_filter,
                        nameForFilter: c.name_for_filter,
                        nameForProduct: c.name_for_product,
                        nameForProductCard: c.name_for_product_card,
                        showInProduct: c.show_in_product,
                        showInProductCard: c.show_in_product_card,
                        hideNameOnProduct: c.hide_name_on_product,
                        hideNameOnProductCard: c.hide_name_on_product_card,
                        filterTemplate: c.filter_template,
                        urlSort: c.url_sort,
                        filterType: c.type,
                    };
                })
            };
        });
        _this.stores = (_f = data.stores) === null || _f === void 0 ? void 0 : _f.map(function (s) {
            return {
                address: s.address,
                cellPhone: s.cell_phone,
                cityId: s.city_id,
                cityName: s.city_name,
                hasPickup: s.has_pickup,
                id: s.id,
                images: s.images,
                lat: s.lat,
                lon: s.lon,
                title: s.title,
                url: s.url,
                workPhone: s.work_phone,
                description: s.description,
                email: s.email,
                image: s.image,
                workingHours: s.working_hours,
                imageId: s.image_id,
                imagesIds: s.images_ids
            };
        });
        _this.brand = {
            id: (_g = data.brand) === null || _g === void 0 ? void 0 : _g.id,
            name: (_h = data.brand) === null || _h === void 0 ? void 0 : _h.name,
            url: (_j = data.brand) === null || _j === void 0 ? void 0 : _j.url,
            country: (_k = data.brand) === null || _k === void 0 ? void 0 : _k.country,
            description: (_l = data.brand) === null || _l === void 0 ? void 0 : _l.description,
            image: (_m = data.brand) === null || _m === void 0 ? void 0 : _m.image,
            secondTitle: (_o = data.brand) === null || _o === void 0 ? void 0 : _o.second_title,
            sort: (_p = data.brand) === null || _p === void 0 ? void 0 : _p.sort
        };
        _this.modifications = (_q = data.modifications) === null || _q === void 0 ? void 0 : _q.map(function (m) {
            return {
                id: m.id,
                name: m.name,
                price: m.price,
                quantity: m.quantity,
                variants: m.variants.map(function (v) {
                    return {
                        id: v.id,
                        label: v.label,
                        image: v.image
                    };
                }),
                oldPrice: m.price_old
            };
        });
        _this.customDataFields = data.customDataFields;
        _this.variants = (_r = data.variants) === null || _r === void 0 ? void 0 : _r.map(function (v) {
            var _a;
            return {
                groupId: v.group_id,
                name: v.name,
                variants: (_a = v.variants) === null || _a === void 0 ? void 0 : _a.map(function (v) {
                    return {
                        id: v.id,
                        label: v.label,
                        image: v.image
                    };
                })
            };
        });
        _this.hasModifications = data.has_modifications;
        _this.productSetImageDots = data.product_set_image_dots;
        _this.options = data.options;
        _this.isProductSet = data.is_product_set;
        _this.isNotAvailable = data.is_not_available;
        _this.hasOptions = data.has_options;
        _this.modificationsCount = data.modifications_count;
        _this.optionGroupsCount = data.option_groups_count;
        _this.sku = data.sku;
        _this.productSetParents = data.productSetParents;
        _this.files = data.files;
        _this.reviewsCount = data.reviews_count;
        _this.reviewsRating = data.reviews_rating;
        _this.productSetChildrenCount = data.product_set_children_count;
        _this.bonusValue = data.bonus_value;
        _this.totalBonusValue = data.bonus_value_total;
        _this.shortCharacteristics = data.short_characteristics;
        _this.additionalCategories = data.additionalCategories;
        _this.characteristicGroup = data.characteristicGroup;
        _this.characteristicGroupId = data.characteristic_group_id;
        _this.isBonusesOutcoming = data.is_bonuses_outcoming;
        _this.exchangeUpdatedAt = data.exchange_updated_at;
        _this.createdAt = data.created_at;
        _this.updatedAt = data.updated_at;
        _this.image = data.image;
        _this.images = (_s = data.images) === null || _s === void 0 ? void 0 : _s.map(function (i) {
            return {
                src: i.src,
                preview: i.preview,
                thumb: i.thumb,
                caption: i.caption,
                imageId: i.imageId,
            };
        });
        _this.promotions = (_t = data.promotions) === null || _t === void 0 ? void 0 : _t.map(function (p) {
            var dynamicFields = __assign({}, p);
            [
                'id', 'startedAt', 'endedAt', 'slug', 'url', 'label', 'iconFileId', 'icon', 'description',
                'visualProfitLabel', 'visualProfitType', 'visualProfitValue', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
            ].map(function (key) {
                delete dynamicFields[key];
            });
            return {
                id: p.id,
                startedAt: p.started_at ? new Date(p.started_at) : undefined,
                endedAt: p.ended_at ? new Date(p.ended_at) : undefined,
                slug: p.slug,
                url: p.url,
                label: p.label,
                iconFileId: p.icon_file_id,
                icon: p.icon,
                description: p.description,
                visualProfitLabel: p.visual_profit_label,
                visualProfitType: p.visual_profit_type,
                visualProfitValue: p.visual_profit_value,
                credit: !p.is_credit ? undefined : {
                    is: p.is_credit,
                    percent: p.credit_percent,
                    term: p.credit_term,
                    type: p.credit_type,
                },
                dynamicFields: dynamicFields
            };
        });
        _this.meta = meta;
        var dynamicFields = __assign({}, data);
        [
            'code', 'name', 'slug', 'description', 'short_description', 'price', 'price_old', 'price_new', 'rating', 'image_id',
            'images_ids', 'quantity', 'count_step', 'depth', 'weight', 'width', 'height', 'is_hit', 'is_new', 'is_special',
            'url', 'allow_out_of_stock', 'unit', 'category', 'categories', 'tags', 'photos', 'characteristics', 'stores',
            'brand', 'modifications', 'customDataFields', 'variants', 'has_modifications', 'product_set_image_dots', 'options',
            'is_product_set', 'is_not_available', 'has_options', 'modifications_count', 'option_groups_count', 'productSetParents',
            'files', 'reviews_count', 'reviews_rating', 'product_set_children_count', 'bonus_value', 'bonus_value_total', 'short_characteristics',
            'additionalCategories', 'characteristicGroup', 'characteristic_group_id', 'is_bonuses_outcoming', 'exchange_updated_at',
            'created_at', 'updated_at', 'image', 'images', 'promotions', 'meta'
        ].map(function (key) {
            delete dynamicFields[key];
        });
        _this.dynamicFields = dynamicFields;
        return _this;
    }
    return Product;
}(BaseEntity_1.BaseEntity));
exports.Product = Product;
;
//# sourceMappingURL=Product.js.map